import { assign, createMachine } from 'xstate';
import type { Scene } from '../shared/scene';

export interface TrialAnswer {
  userAnswer: number;
  noticed: boolean;
  confidence: number;
  anomalyText?: string;
  reactionMs: number;
}

interface TrialContext {
  scene?: Scene;
  answer?: TrialAnswer;
  error?: string;
}

type TrialEvent =
  | { type: 'START' }
  | { type: 'SCENE_READY'; scene: Scene }
  | { type: 'FAIL'; error: string }
  | { type: 'BEGIN' }
  | { type: 'FINISH' }
  | { type: 'ANSWER'; answer: TrialAnswer }
  | { type: 'SUBMIT' }
  | { type: 'SUBMITTED' }
  | { type: 'AGAIN' };

export const trialMachine = createMachine({
  id: 'plainSightTrial',
  initial: 'idle',
  types: {} as { context: TrialContext; events: TrialEvent },
  context: {},
  states: {
    idle: { on: { START: 'loading' } },
    loading: {
      entry: assign({ scene: undefined, answer: undefined, error: undefined }),
      on: {
        SCENE_READY: { target: 'briefing', actions: assign({ scene: ({ event }) => event.scene }) },
        FAIL: { target: 'error', actions: assign({ error: ({ event }) => event.error }) }
      }
    },
    briefing: { on: { BEGIN: 'running', AGAIN: 'loading' } },
    running: { on: { FINISH: 'answering' } },
    answering: {
      on: {
        ANSWER: { target: 'reveal', actions: assign({ answer: ({ event }) => event.answer }) }
      }
    },
    reveal: { on: { SUBMIT: 'submitting', AGAIN: 'loading' } },
    submitting: { on: { SUBMITTED: 'submitted', FAIL: { target: 'reveal', actions: assign({ error: ({ event }) => event.error }) } } },
    submitted: { on: { AGAIN: 'loading' } },
    error: { on: { AGAIN: 'loading' } }
  }
});
